// shared/domain/ciclo.js  (reglas puras sobre ciclos)

/**
 * Ciclo activo = el último de la lista, mismo criterio que `SelectCiclo` (src/components/select/select-ciclo.jsx).
 * Devuelve el id o null si no hay ciclos.
 */
export const cicloActivoId = (ciclos = []) => (ciclos.length ? ciclos[ciclos.length - 1].id : null);

/**
 * Al crear, el backend NO asigna el ciclo activo, pero el listado sí filtra por él:
 * sin ciclo el registro "desaparece". Por eso se propone el ciclo activo por defecto.
 */
export const conCicloPorDefecto = (entity, ciclos = []) =>
  entity && (entity.id_ciclo === null || entity.id_ciclo === undefined) ? { ...entity, id_ciclo: cicloActivoId(ciclos) } : entity;
